<template>
  <div
    class="side-nav"
    :class="{
      'openwidth-sidebar': menuStatus,
      trans: !menuStatus,
      'closewidth-sidebar': !menuStatus,
    }"
    @mouseleave="resetVariablesOnMouseLeave(), restMyCondition()"
    @mouseenter="setVariablesOnMouseEnter(), (closedBar = true)"
  >
    <div
      class="side-close pointer"
      :style="!menuStatus && 'padding-left: 9px !important;'"
      v-if="menuStatus"
      @click="closeSideBar"
    >
      <img src="../../assets/img/sidebar/MenuClose.svg" alt="" />
    </div>
    <div class="side-menu-main">
      <ul class="list-unstyled">
        <li
          style="width: 98%"
          v-if="roles.includes('VIEW_DASHBOARD')"
          @click="goToMainDashboard()"
          class="d-flex align-items-center"
          @mouseenter="hoverComp = 'mainDashboard'"
          @mouseleave="hoverComp = null"
        >
          <div class="hw-24">
            <img
              v-if="checkDashboard"
              style="cursor: default"
              src="../../assets/img/sidebar/dashboardac.svg"
              alt=""
            />

            <img
              v-else-if="hoverComp === 'mainDashboard'"
              src="../../assets/img/sidebar/blueDashboard.svg"
              alt=""
            />
            <img v-else src="../../assets/img/sidebar/dashboardin.svg" alt="" />
          </div>

          <span
            :class="
              checkDashboard ? 'head-activenavclass' : 'head-inactivenavclass'
            "
            class="pl-3"
            >Dashboard</span
          >
        </li>

        <li
          style="width: 98%"
          v-if="roles.includes('JOB_VIEW') || roles.includes('RECRUITER_VIEW')"
          @click="goToJobDashboard"
          class="d-flex align-items-center"
          @mouseenter="hoverComp = 'jobDashboard'"
          @mouseleave="hoverComp = null"
        >
          <div class="hw-24">
            <img
              v-if="checkJobDashboard"
              style="cursor: default"
              src="../../assets/img/sidebar/job-dashboard-selected.svg"
              alt=""
            />

            <img
              v-else-if="hoverComp === 'jobDashboard'"
              src="../../assets/img/sidebar/job-dashboard-hover.svg"
              alt=""
            />
            <img
              v-else
              src="../../assets/img/sidebar/job-dashboard-unselected.svg"
              alt=""
            />
          </div>

          <span
            :class="
              checkJobDashboard
                ? 'head-activenavclass'
                : 'head-inactivenavclass'
            "
            class="pl-3"
            >Job Dashboard</span
          >
        </li>

        <li
          style="width: 98%"
          v-if="roles.includes('GET_WORKBENCH')"
          @click="goToWorkBench()"
          class="d-flex align-items-center"
          @mouseenter="hoverComp = 'customer'"
          @mouseleave="hoverComp = null"
        >
          <div class="hw-24 mr-1px">
            <img
              v-if="checkWorkBench"
              style="cursor: default"
              src="../../assets/img/sidebar/customerSel.svg"
              alt=""
            />

            <img
              v-else-if="hoverComp === 'customer'"
              src="../../assets/img/sidebar/customerBlue.svg"
              alt=""
            />
            <img
              v-else
              src="../../assets/img/sidebar/customerGrey.svg"
              alt=""
            />
          </div>
          <span
            :class="
              checkWorkBench ? 'head-activenavclass' : 'head-inactivenavclass'
            "
            class="pl-3"
            >Workbench</span
          >
        </li>

        <li
          style="width: 98%"
          v-if="roles.includes('GET_CUSTOMER') || roles.includes('GET_VENDOR')"
          @click="showManage = !showManage"
          class="d-flex align-items-center justify-content-between pointer"
          @mouseenter="hoverComp = 'manage'"
          @mouseleave="hoverComp = null"
        >
          <div class="d-flex align-items-center w-100 justify-content-between">
            <div class="d-flex align-items-center">
              <div class="hw-24">
                <img
                  v-if="checkManage"
                  style="cursor: default"
                  src="../../assets/img/sidebar/acmanage.svg"
                  alt=""
                />
                <img
                  v-else-if="hoverComp === 'manage'"
                  src="../../assets/img/sidebar/blueManage.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../assets/img/sidebar/inmanage.svg"
                  alt=""
                />
              </div>

              <span
                class="pl-3"
                :class="
                  checkManage ? 'head-activenavclass' : 'head-inactivenavclass'
                "
                >Manage</span
              >
            </div>
            <div>
              <img
                v-if="!showManage"
                src="../../assets/img/sidebar/inactivedownarrow.svg"
                alt
              />
              <img
                v-else
                src="../../assets/img/sidebar/inactiveuparrow.svg"
                alt
              />
            </div>
          </div>
        </li>
        <div class="d-flex mt-2 innerOptions w-100" v-if="showManage">
          <!-- <div class="sub-line"></div> -->
          <div class="w-100">
            <div
              v-if="roles.includes('GET_CUSTOMER')"
              @click="goToCustomer()"
              class="d-flex align-items-center justify-content-between"
              @mouseenter="hoverComp = 'custline'"
              @mouseleave="hoverComp = null"
            >
              <div v-if="hoverComp === 'custline'" class="sub-line"></div>
              <div v-else class="sub-line-white"></div>
              <span
                :class="
                  checkCustomer ? 'sub-activenavclass' : 'sub-inactivenavclass '
                "
                >Customer</span
              >
            </div>

            <div
              v-if="roles.includes('GET_VENDOR')"
              @click="goToVendor()"
              class="d-flex align-items-center justify-content-between mt-2"
              @mouseenter="hoverComp = 'vendorline'"
              @mouseleave="hoverComp = null"
            >
              <div v-if="hoverComp === 'vendorline'" class="sub-line"></div>
              <div v-else class="sub-line-white"></div>
              <span
                :class="
                  checkVendor ? 'sub-activenavclass' : 'sub-inactivenavclass '
                "
                >Vendor</span
              >
            </div>
          </div>
        </div>
        <!-- class= selected-option -->
        <li
          style="width: 98%"
          v-if="
            roles.includes('VIEW_ADMIN') ||
            roles.includes('GET_PANEL') ||
            roles.includes('GET_ROLE') ||
            roles.includes('SUB_ADMIN')
          "
          @click="showPermissions = !showPermissions"
          class="d-flex align-items-center justify-content-between pointer"
          @mouseenter="hoverComp = 'access'"
          @mouseleave="hoverComp = null"
        >
          <!-- :class="
            checkPermissions &&
            !showPermissions &&
            closedBar &&
            'selected-option'
          " -->
          <div class="d-flex align-items-center w-100 justify-content-between">
            <div class="d-flex align-items-center">
              <div class="hw-24 mr-1px">
                <img
                  v-if="
                    (showPermissions && checkPermissions) ||
                    (checkPermissions && !showPermissions && !closedBar)
                  "
                  src="../../assets/img/sidebar/blueRoundaccess.svg"
                  alt=""
                />
                <img
                  v-else-if="hoverComp === 'access' || checkPermissions"
                  style="cursor: default"
                  src="../../assets/img/sidebar/acaccess.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../assets/img/sidebar/inaccess.svg"
                  alt=""
                />
              </div>

              <span
                id="AccessPanel"
                class="pl-3"
                :class="
                  checkPermissions
                    ? 'head-activenavclass'
                    : 'head-inactivenavclass'
                "
                >User Management</span
              >
            </div>
            <div class="d-flex justify-content-end">
              <!-- <img
              v-if="checkPermissions && showPermissions"
              src="../../assets/img/sidebar/activeuparrow.svg"
              alt
            />
            <img
              v-else-if="!checkPermissions && showPermissions"
              src="../../assets/img/sidebar/inactiveuparrow.svg"
              alt
            /> -->
              <img
                v-if="!showPermissions"
                src="../../assets/img/sidebar/inactivedownarrow.svg"
                alt
              />
              <img
                v-else
                src="../../assets/img/sidebar/inactiveuparrow.svg"
                alt
              />
            </div>
          </div>
        </li>
        <div class="d-flex mt-2 innerOptions w-100" v-if="showPermissions">
          <div class="w-100">
            <div
              v-if="roles.includes('VIEW_ADMIN') || roles.includes('SUB_ADMIN')"
              @click="goToAccessPanel()"
              class="d-flex align-items-center w-100"
              @mouseenter="hoverComp = 'user'"
              @mouseleave="hoverComp = null"
            >
              <div v-if="hoverComp === 'user'" class="sub-line"></div>
              <div v-else class="sub-line-white"></div>
              <span
                id="Users"
                :class="
                  checkUsers ? 'sub-activenavclass' : 'sub-inactivenavclass '
                "
                >Users</span
              >
            </div>

            <div
              v-if="roles.includes('GET_ROLE')"
              @click="goToRoles()"
              class="d-flex align-items-center mt-2"
              @mouseenter="hoverComp = 'role'"
              @mouseleave="hoverComp = null"
            >
              <div v-if="hoverComp === 'role'" class="sub-line"></div>
              <div v-else class="sub-line-white"></div>
              <span
                id="Roles"
                :class="
                  checkRoles ? 'sub-activenavclass' : 'sub-inactivenavclass '
                "
                >Roles</span
              >
            </div>
            <div
              v-if="roles.includes('GET_PANEL')"
              @click="goToPanellist()"
              class="d-flex align-items-center mt-2"
              @mouseenter="hoverComp = 'panel'"
              @mouseleave="hoverComp = null"
            >
              <div v-if="hoverComp === 'panel'" class="sub-line"></div>
              <div v-else class="sub-line-white"></div>
              <span
                id="Panelist"
                :class="
                  checkPanel ? 'sub-activenavclass' : 'sub-inactivenavclass '
                "
                >Panelist</span
              >
            </div>
          </div>
        </div>

        <li
          v-if="roles.includes('GET_VENDOR_DASHBOARD')"
          @click="gotovendorlogin()"
          class="d-flex align-items-center"
          @mouseenter="hoverComp = 'vendor'"
          @mouseleave="hoverComp = null"
        >
          <img
            v-if="checkvendors"
            style="cursor: default"
            src="../../assets/img/sidebar/dashboardac.svg"
            alt=""
          />
          <img
            v-else-if="hoverComp === 'vendor'"
            style="cursor: default"
            src="../../assets/img/sidebar/blueDashboard.svg"
            alt=""
          />
          <img v-else src="../../assets/img/sidebar/dashboardin.svg" alt="" />
          <span
            :class="
              checkvendors ? 'head-activenavclass' : 'head-inactivenavclass'
            "
            class="pl-3"
            >Dashboard</span
          >
        </li>

        <li
          style="width: 98%"
          v-if="roles.includes('GET_TALENTPOOL')"
          @click="goToTalentPool()"
          class="d-flex align-items-center"
          @mouseenter="hoverComp = 'talentPool'"
          @mouseleave="hoverComp = null"
        >
          <div class="hw-24 mr-1px">
            <img
              v-if="checkTalent"
              style="cursor: default"
              src="../../assets/img/sidebar/blueTalent.svg"
              alt=""
            />

            <img
              v-else-if="hoverComp === 'talentPool'"
              src="../../assets/img/sidebar/actalentpool.svg"
              alt=""
            />
            <img
              v-else
              src="../../assets/img/sidebar/intalentpool.svg"
              alt=""
            />
          </div>

          <span
            :class="
              checkTalent ? 'head-activenavclass' : 'head-inactivenavclass'
            "
            class="pl-3"
            >Talent Pool</span
          >
        </li>

        <li
          style="width: 98%"
          v-if="checkForReports"
          @click="goToReport()"
          class="d-flex align-items-center"
          @mouseenter="hoverComp = 'reports'"
          @mouseleave="hoverComp = null"
        >
          <div class="hw-24">
            <img
              v-if="checkReports"
              style="cursor: default"
              src="../../assets/img/sidebar/acreport.svg"
              alt=""
            />
            <img
              v-else-if="hoverComp === 'reports'"
              src="../../assets/img/sidebar/blueReport.svg"
              alt=""
            />
            <img v-else src="../../assets/img/sidebar/inreport.svg" alt="" />
          </div>

          <span
            :class="
              checkReports ? 'head-activenavclass' : 'head-inactivenavclass'
            "
            class="pl-3"
            >Reports</span
          >
        </li>

        <li
          style="width: 98%"
          v-if="
            roles.includes('GET_INTERVIEW') ||
            roles.includes('GET_FEEDBACK_FORM')
          "
          @click="showInterview = !showInterview"
          class="d-flex align-items-center justify-content-between pointer"
          @mouseenter="hoverComp = 'hiringProcess'"
          @mouseleave="hoverComp = null"
        >
          <div class="d-flex align-items-center w-100 justify-content-between">
            <div class="d-flex align-items-center">
              <div class="hw-24">
                <img
                  v-if="checkInterview"
                  style="cursor: default"
                  src="../../assets/img/sidebar/acinterviewprocess.svg"
                  alt=""
                />
                <img
                  v-else-if="hoverComp === 'hiringProcess'"
                  style="cursor: default"
                  src="../../assets/img/sidebar/blueHirPro.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../assets/img/sidebar/initerviewprocess.svg"
                  alt=""
                />
              </div>
              <span
                class="pl-3"
                :class="
                  checkInterview
                    ? 'head-activenavclass'
                    : 'head-inactivenavclass'
                "
                >Hiring Process</span
              >
            </div>
            <div class="d-flex justify-content-end">
              <img
                v-if="!showInterview"
                src="../../assets/img/sidebar/inactivedownarrow.svg"
                alt
              />
              <img
                v-else
                src="../../assets/img/sidebar/inactiveuparrow.svg"
                alt
              />
            </div>
          </div>
        </li>

        <div class="d-flex mt-2 innerOptions w-100" v-if="showInterview">
          <div class="w-100">
            <div
              v-if="roles.includes('GET_INTERVIEW')"
              @click="goToRoute('interviewProcess')"
              class="d-flex align-items-center"
              @mouseenter="hoverComp = 'interview'"
              @mouseleave="hoverComp = null"
            >
              <div v-if="hoverComp === 'interview'" class="sub-line"></div>
              <div v-else class="sub-line-white"></div>
              <span
                :class="
                  checkIP ? 'sub-activenavclass' : 'sub-inactivenavclass '
                "
                >Interview Process</span
              >
            </div>

            <div
              v-if="roles.includes('GET_FEEDBACK_FORM')"
              @click="goToRoute('feedbackForm')"
              class="d-flex align-items-center mt-2"
              @mouseenter="hoverComp = 'feedback'"
              @mouseleave="hoverComp = null"
            >
              <div v-if="hoverComp === 'feedback'" class="sub-line"></div>
              <div v-else class="sub-line-white"></div>
              <span
                :class="
                  checkFeed ? 'sub-activenavclass' : 'sub-inactivenavclass '
                "
                >Feedback Form</span
              >
            </div>
          </div>
        </div>

        <li
          style="width: 98%"
          v-if="roles.includes('GET_HRPORTAL')"
          @click="showPortal = !showPortal"
          class="d-flex align-items-center justify-content-between pointer"
        >
          <div class="d-flex align-items-center w-100 justify-content-between">
            <div>
              <img
                v-if="checkPortal"
                style="cursor: default"
                src="../../assets/img/sidebar/acportal.svg"
                alt=""
              />
              <img
                v-else
                src="../../assets/img/sidebar/inhrportal.svg"
                alt=""
              />
              <span
                class="pl-3"
                :class="
                  checkPortal ? 'head-activenavclass' : 'head-inactivenavclass'
                "
                >HR Portal</span
              >
            </div>
            <div>
              <img
                v-if="showPortal && checkPortal"
                src="../../assets/img/sidebar/activeuparrow.svg"
                alt
              />
              <img
                v-else-if="!checkPortal && showPortal"
                src="../../assets/img/sidebar/inactiveuparrow.svg"
                alt
              />
              <img
                v-else-if="checkPortal && !showPortal"
                src="../../assets/img/sidebar/activedownarrow.svg"
                alt
              />
              <img
                v-else
                src="../../assets/img/sidebar/inactivedownarrow.svg"
                alt
              />
            </div>
          </div>
        </li>
        <div class="d-flex mt-2 innerOptions w-100" v-if="showPortal">
          <div class="w-100">
            <div
              v-if="roles.includes('GET_HRPORTAL')"
              @click="goToHrPortal()"
              class="d-flex align-items-center"
              @mouseenter="hoverComp = 'hrPortal'"
              @mouseleave="hoverComp = null"
            >
              <div v-if="hoverComp === 'hrPortal'" class="sub-line"></div>
              <div v-else class="sub-line-white"></div>
              <span
                id="Dashboard"
                :class="
                  checkHR ? 'sub-activenavclass' : 'sub-inactivenavclass '
                "
                >Dashboard</span
              >
            </div>

            <div
              v-if="roles.includes('GET_HRPORTAL')"
              @click="goToUploaddocuments()"
              class="d-flex align-items-center mt-2"
              @mouseenter="hoverComp = 'uploadDoc'"
              @mouseleave="hoverComp = null"
            >
              <div v-if="hoverComp === 'uploadDoc'" class="sub-line"></div>
              <div v-else class="sub-line-white"></div>
              <span
                id="Documents"
                :class="
                  checkUploadDocs
                    ? 'sub-activenavclass'
                    : 'sub-inactivenavclass '
                "
              >
                Upload Documents</span
              >
            </div>
          </div>
        </div>

        <li
          style="width: 98%"
          v-if="
            roles.includes('GET_JD_APPROVAL') ||
            roles.includes('GET_ACCEPT_CANDIDATE')
          "
          @click="showApproval = !showApproval"
          class="d-flex align-items-center pointer"
          @mouseenter="hoverComp = 'approval'"
          @mouseleave="hoverComp = null"
        >
          <div class="d-flex align-items-center w-100 justify-content-between">
            <div class="d-flex align-items-center">
              <div class="hw-24 mr-1px">
                <img
                  v-if="checkApproval"
                  style="cursor: default"
                  src="../../assets/img/sidebar/approvalSel.svg"
                  alt=""
                />

                <img
                  v-else-if="hoverComp === 'approval'"
                  src="../../assets/img/sidebar/JDapprovalblue.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../assets/img/sidebar/JDapprovalgrey.svg"
                  alt=""
                />
              </div>
              <span
                class="pl-3"
                :class="
                  checkApproval
                    ? 'head-activenavclass'
                    : 'head-inactivenavclass'
                "
                >Approval</span
              >
            </div>
            <div class="d-flex justify-content-end">
              <img
                v-if="!showApproval"
                src="../../assets/img/sidebar/inactivedownarrow.svg"
                alt
              />
              <img
                v-else
                src="../../assets/img/sidebar/inactiveuparrow.svg"
                alt
              />
            </div>
          </div>
        </li>
        <div class="d-flex mt-2 innerOptions w-100" v-if="showApproval">
          <div class="w-100">
            <div
              v-if="roles.includes('GET_JD_APPROVAL')"
              @click="gotojdapproval()"
              class="d-flex align-items-center"
              @mouseenter="hoverComp = 'jdApproval'"
              @mouseleave="hoverComp = null"
            >
              <div v-if="hoverComp === 'jdApproval'" class="sub-line"></div>
              <div v-else class="sub-line-white"></div>
              <span
                :class="
                  checkJD ? 'sub-activenavclass' : 'sub-inactivenavclass '
                "
                >Job Approval</span
              >
            </div>

            <div
              v-if="roles.includes('GET_ACCEPT_CANDIDATE')"
              @click="gotocandidateapproval()"
              class="d-flex align-items-center mt-2"
              @mouseenter="hoverComp = 'candApproval'"
              @mouseleave="hoverComp = null"
            >
              <div v-if="hoverComp === 'candApproval'" class="sub-line"></div>
              <div v-else class="sub-line-white"></div>
              <span
                :class="
                  checkCand ? 'sub-activenavclass' : 'sub-inactivenavclass '
                "
                >Candidate Approval</span
              >
            </div>
          </div>
        </div>

        <li
          style="width: 98%"
          v-if="roles.includes('GET_TEAMS')"
          @click="gotoTeams()"
          class="d-flex align-items-center"
          @mouseenter="hoverComp = 'teams'"
          @mouseleave="hoverComp = null"
        >
          <div class="hw-24 mr-1px">
            <img
              v-if="checkTeams"
              style="cursor: default"
              src="../../assets/img/sidebar/teamsActive.svg"
              alt=""
            />
            <img
              v-else-if="hoverComp === 'teams'"
              src="../../assets/img/sidebar/blueteamsInactive.svg"
              alt=""
            />
            <img
              v-else
              src="../../assets/img/sidebar/teamsInactive.svg"
              alt=""
            />
          </div>
          <span
            :class="
              checkTeams ? 'head-activenavclass' : 'head-inactivenavclass'
            "
            class="pl-3"
            >Teams</span
          >
        </li>

        <li
          style="width: 98%"
          v-if="roles.includes('GET_PANEL_DASHBOARD')"
          @click="gotoPanelLogin()"
          class="d-flex align-items-center"
          @mouseenter="hoverComp = 'panelist'"
          @mouseleave="hoverComp = null"
        >
          <!-- <img
            v-if="checkPanelLogin"
            style="cursor: default"
            src="../../assets/img/sidebar/panel-dashboard-active.svg"
            alt=""
          />
          <img
            v-else
            src="../../assets/img/sidebar/panel-dashboard-icon.svg"
            alt=""
          /> -->
          <div class="hw-24">
            <img
              v-if="checkPanelLogin"
              style="cursor: default"
              src="../../assets/img/sidebar/panelselected.svg"
              alt=""
            />

            <img
              v-else-if="hoverComp === 'panelist'"
              src="../../assets/img/sidebar/panelSel.svg"
              alt=""
            />
            <img v-else src="../../assets/img/sidebar/greypanel.svg" alt="" />
          </div>
          <span
            v-if="roles.includes('GET_PANEL_DASHBOARD')"
            :class="
              checkPanelLogin ? 'head-activenavclass' : 'head-inactivenavclass'
            "
            class="pl-3"
          >
            {{
              roles.includes("VIEW_DASHBOARD") ? "Panel Dashboard" : "Dashboard"
            }}
          </span>
        </li>
        <li
          v-if="roles.includes('GET_DOCUMENT')"
          style="width: 98%"
          @click="goToDocuments"
          class="d-flex align-items-center"
          @mouseenter="hoverComp = 'hrDocuments'"
          @mouseleave="hoverComp = null"
        >
          <div class="hw-24">
            <img
              v-if="checkHRDocuments"
              style="cursor: default"
              src="../../assets/img/sidebar/documents-selected.svg"
              alt=""
            />
            <img
              v-else-if="hoverComp === 'hrDocuments'"
              src="../../assets/img/sidebar/documents-hover.svg"
              alt=""
            />
            <img
              v-else
              src="../../assets/img/sidebar/documents-unselected.svg"
              alt=""
            />
          </div>

          <span
            :class="
              checkHRDocuments ? 'head-activenavclass' : 'head-inactivenavclass'
            "
            class="pl-3"
            >Documents</span
          >
        </li>
        <li
          style="width: 98%"
          v-if="roles.includes('GET_FORM') || roles.includes('GET_THIRD_PARTY')"
          @click="showConfigure = !showConfigure"
          class="d-flex align-items-center justify-content-between pointer"
          @mouseenter="hoverComp = 'configure'"
          @mouseleave="hoverComp = null"
        >
          <div class="d-flex align-items-center w-100 justify-content-between">
            <div class="d-flex align-items-center">
              <div class="hw-24 mr-1px">
                <img
                  v-if="checkConfigure"
                  style="cursor: default"
                  src="../../assets/img/sidebar/thirdpartyicon.svg"
                  alt=""
                />
                <img
                  v-else-if="hoverComp === 'configure'"
                  src="../../assets/img/sidebar/configureBlue.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../assets/img/sidebar/configureGrey.svg"
                  alt=""
                />
              </div>
              <span
                class="pl-3"
                :class="
                  checkConfigure
                    ? 'head-activenavclass'
                    : 'head-inactivenavclass'
                "
                >Configure</span
              >
            </div>
            <div>
              <img
                v-if="!showConfigure"
                src="../../assets/img/sidebar/inactivedownarrow.svg"
                alt
              />
              <img
                v-else
                src="../../assets/img/sidebar/inactiveuparrow.svg"
                alt
              />
            </div>
          </div>
        </li>
        <div class="d-flex mt-2 innerOptions w-100" v-if="showConfigure">
          <div class="w-100">
            <div
              v-if="roles.includes('GET_FORM')"
              @click="gotoCustomField()"
              class="d-flex align-items-center"
              @mouseenter="hoverComp = 'form'"
              @mouseleave="hoverComp = null"
            >
              <div v-if="hoverComp === 'form'" class="sub-line"></div>
              <div v-else class="sub-line-white"></div>
              <span
                :class="
                  checkCustomFields
                    ? 'sub-activenavclass'
                    : 'sub-inactivenavclass '
                "
                >Custom Fields</span
              >
            </div>

            <div
              v-if="roles.includes('GET_THIRD_PARTY')"
              @click="gotoThirdParty()"
              class="d-flex align-items-center mt-2"
              @mouseenter="hoverComp = 'thirdParty'"
              @mouseleave="hoverComp = null"
            >
              <div v-if="hoverComp === 'thirdParty'" class="sub-line"></div>
              <div v-else class="sub-line-white"></div>
              <span
                :class="
                  checkThirdParty
                    ? 'sub-activenavclass'
                    : 'sub-inactivenavclass '
                "
                >Third Party</span
              >
            </div>
          </div>
        </div>

        <!-- transactions -->
        <li
          v-if="roles.includes('GET_TRANSACTIONS')"
          style="width: 98%"
          @click="goToTransactions()"
          class="d-flex align-items-center"
          @mouseenter="hoverComp = 'transactions'"
          @mouseleave="hoverComp = null"
        >
          <div class="hw-24 mr-1px">
            <img
              v-if="checkTransactions"
              style="cursor: default"
              src="../../assets/img/sidebar/trans-active.svg"
              alt=""
            />
            <img
              v-else-if="hoverComp === 'transactions'"
              src="../../assets/img/sidebar/trans-hover.svg"
              alt=""
            />
            <img
              v-else
              src="../../assets/img/sidebar/transinactive.svg"
              alt=""
            />
          </div>
          <span
            :class="
              checkTransactions
                ? 'head-activenavclass'
                : 'head-inactivenavclass'
            "
            class="pl-3"
            >Transactions</span
          >
        </li>

        <!-- Cv Search -->
        <!-- <li v-if="roles.includes('GET_CV_SEARCH')" @click="goToCvSearch()">
          <img
            v-if="checkCvSearch"
            style="cursor: default"
            src="../../assets/img/sidebar/cvsearchred.svg"
            alt=""
          />
          <img v-else src="../../assets/img/sidebar/cvsearchgray.svg" alt="" />
          <span
            class="pl-1"
            :class="
              checkCvSearch ? 'head-activenavclass' : 'head-inactivenavclass'
            "
          >
            CV Search
          </span>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SideBar",
  data() {
    return {
      hoverComp: null,
      closedBar: true,
      mini: true,
      dropValue: false,
      showPermissions: false,
      showInterview: false,
      showApproval: false,
      showPortal: false,
      showManage: false,
      showConfigure: false,
    };
  },
  watch: {
    menuStatus(value) {
      if (!value) {
        this.showPermissions = false;
        this.showInterview = false;
        this.showApproval = false;
        this.showPortal = false;
        this.showConfigure = false;
        this.showManage = false;
      }
    },
  },
  created() {
    if (this.checkPermissions) {
      this.restMyCondition();
    }
  },
  computed: {
    ...mapGetters(["roles"]),
    ...mapGetters("userVUEX", {
      menuStatus: "getMenuStatus",
      currentComponent: "getCurrentComponent",
    }),

    // check route to dashboard
    checkDashboard() {
      const paths = ["MainDashboard"];
      return paths.includes(this.$route.name);
    },

    checkJobDashboard() {
      const paths = ["JobDashboard"];
      return paths.includes(this.$route.name);
    },

    checkHRDocuments() {
      const paths = ["Documents"];
      return paths.includes(this.$route.name);
    },

    // check route to workbench
    checkWorkBench() {
      const paths = [
        "workBench",
        "InternalHiringDashboard",
        "JdDetails",
        "CreateJob",
        "Kanban",
        "ApplicationTable",
        "ApplicationPreview",
        "AddCandidateInJD",
        "viewRequiredCandidateDocs",
        "EditCandidateInJD",
        "cvSearchKanban",
        "Analytics",
        "OnboardingDocuments",
        "BotAnalysis",
      ];
      if (this.currentComponent === "Workbench") {
        paths.push(
          "BookmarkedCandidates",
          "ViewCandidateProfile",
          "SearchCandidate",
          "AddFromThirdParty"
        );
      }

      return (
        paths.includes(this.$route.name) ||
        (this.$route.name == "ViewCandidateProfile" &&
          this.$route.query.from == "kanban")
      );
    },

    // check route to manage
    checkManage() {
      const paths = [
        "Manage",
        "AddCustomer",
        "EditCustomer",
        "AddVendor",
        "EditVendor",
        "ActivateVendor",
        "ActivateCustomer",
      ];
      return paths.includes(this.$route.name);
    },
    // check route to configure
    checkConfigure() {
      const paths = ["customfield", "customform", "customtable", "ThirdParty"];
      return paths.includes(this.$route.name);
    },
    // CHECK ACCESS CONTROL
    checkPermissions() {
      const paths = ["AccessControl", "Panellist", "AddPanel", "EditPanel"];
      return paths.includes(this.$route.name);
    },
    checkUsers() {
      return (
        this.$route.fullPath == "/permission/access?status=users" ||
        this.$route.fullPath == "/permission/access"
      );
    },
    checkCustomer() {
      const paths = ["AddCustomer", "EditCustomer", "ActivateCustomer"];
      return (
        this.$route.fullPath.startsWith("/data/manage?status=customer") ||
        paths.includes(this.$route.name)
      );
    },
    checkVendor() {
      const paths = ["AddVendor", "EditVendor", "ActivateVendor"];
      return (
        this.$route.fullPath.startsWith("/data/manage?status=manage") ||
        paths.includes(this.$route.name)
      );
    },
    checkRoles() {
      return this.$route.fullPath == "/permission/access?status=roles";
    },

    // check route to panelist
    checkPanel() {
      const paths = ["Panellist", "AddPanel", "EditPanel"];
      return paths.includes(this.$route.name);
    },

    // check route to access control
    checkAccess() {
      const paths = ["AccessControl"];
      return paths.includes(this.$route.name);
    },

    // check route to talent pool
    checkTalent() {
      const paths = [
        "TalentPool",
        "AddCandidate",
        "EditCandidate",
        "cvSearchTalentPool",
        "Bookmark",
      ];
      if (this.currentComponent === "TalentPool") {
        paths.push(
          "BookmarkedCandidates",
          "ViewCandidateProfile",
          "SearchCandidate",
          "AddFromThirdParty"
        );
      }
      return (
        paths.includes(this.$route.name) ||
        (this.$route.name == "viewRequiredCandidateDocs" &&
          this.$route.query.from == "TalentPool")
      );
    },

    // check route to reports
    checkReports() {
      const paths = [
        "ReportDashboard",
        "CustomerReport",
        "RecruiterReport",
        "VendorReport",
        "PanelistReport",
      ];
      return paths.includes(this.$route.name);
    },

    // check route to Interview process
    checkIP() {
      const paths = [
        "CreateInterviewProcess",
        "EditInterviewProcess",
        "ActivateInterview",
      ];

      return (
        this.$route.fullPath.startsWith(
          "/hiringprocess/dashboard?type=1&sort=6&status=interviewProcess"
        ) || paths.includes(this.$route.name)
      );
    },
    checkInterview() {
      const paths = [
        "InterviewProcessDashboard",
        "HiringProcessDashboard",
        "CreateInterviewProcess",
        "EditInterviewProcess",
        "Feedbackform",
        "ActivateInterview",
        "PreviewFeedbackform Dashboard",
        "Feedbackform Dashboard",
        "EditFeedbackform",
        "ActivateFeedbackForm",
      ];
      return paths.includes(this.$route.name);
    },
    // check route to vendor dashboard
    checkvendors() {
      const paths = [
        "VendorKanban",
        "clientdashboard",
        "jobs",
        "AddCandidateInVendor",
      ];
      return (
        paths.includes(this.$route.name) ||
        (this.$route.name == "ViewCandidateProfile" &&
          this.$route.query.from == "vendorkanban") ||
        (this.$route.name == "viewRequiredCandidateDocs" &&
          this.$route.query.from == "VendorKanban")
      );
    },
    // check route to feedback form
    checkFeed() {
      const paths = [
        "Feedbackform Dashboard",
        "EditFeedbackform",
        "ActivateFeedbackForm",
      ];
      return (
        this.$route.fullPath.startsWith(
          "/hiringprocess/dashboard?type=1&sort=6&status=feedbackForm"
        ) || paths.includes(this.$route.name)
      );
    },

    // check route to candidate
    checkCand() {
      const paths = ["ReviewCandidates", "ViewCandidateStatus", "PreviewOpsheadCandidateProfile"];
      return paths.includes(this.$route.name);
    },
    // check route to HR portal
    checkPortal() {
      const paths = [
        "Dashboard",
        "SelectedCandidates",
        "OnboardingCandidates",
        "RejectedCandidates",
        "ViewOnboardingCandidate",
        "SendAppointment",
        "OfferLetter",
        "EditOfferLetter",
        "TemplatesOfferLetter",
        "CandidateDetails",
        "Uploaddocuments",
      ];
      return paths.includes(this.$route.name);
    },
    checkHR() {
      const paths = [
        "Dashboard",
        "SelectedCandidates",
        "OnboardingCandidates",
        "RejectedCandidates",
        "ViewOnboardingCandidate",
        "SendAppointment",
        "OfferLetter",
        "EditOfferLetter",
        "TemplatesOfferLetter",
        "CandidateDetails",
      ];
      return paths.includes(this.$route.name);
    },

    // check route to JD approval
    checkJD() {
      const paths = ["ViewJds"];
      return paths.includes(this.$route.name);
    },
    checkApproval() {
      const paths = ["ViewJds", "ReviewCandidates", "ViewCandidateStatus", "PreviewOpsheadCandidateProfile"];
      return paths.includes(this.$route.name);
    },
    // check route to teams
    checkTeams() {
      const paths = ["Teams"];
      return paths.includes(this.$route.name);
    },

    // check route to panel login
    checkPanelLogin() {
      const paths = ["PanelLogin", "GiveFeedback"];
      return paths.includes(this.$route.name);
    },
    checkUploadDocs() {
      const paths = ["Uploaddocuments"];
      return paths.includes(this.$route.name);
    },
    checkCvSearch() {
      const paths = ["cvSearch", "SearchCandidate", "Viewcandidateprofile"];
      return paths.includes(this.$route.name);
    },
    checkCustomFields() {
      const paths = ["customfield", "customform", "customtable"];
      return paths.includes(this.$route.name);
    },
    checkThirdParty() {
      const paths = ["ThirdParty"];
      return paths.includes(this.$route.name);
    },
    checkForReports() {
      return (
        this.roles.includes("GET_REPORT_CUSTOMER") ||
        this.roles.includes("GET_REPORT_RECRUITER") ||
        this.roles.includes("GET_REPORT_PANELIST") ||
        this.roles.includes("GET_REPORT_VENDOR") ||
        this.roles.includes("GET_REPORT_MANAGEMENT")
      );
    },

    checkTransactions() {
      const paths = ["Transactions"];
      return paths.includes(this.$route.name);
    },
  },
  methods: {
    resetVariablesOnMouseLeave() {
      // Reset variables to false on mouse leave
      if (!this.menuStatus) {
        this.showManage = false;
        this.showApproval = false;
        this.showInterview = false;
        this.showPortal = false;
        this.showConfigure = false;
        this.showPermissions = false;
      }
    },
    restMyCondition() {
      this.closedBar = false;
    },
    setVariablesOnMouseEnter() {
      // Define an array of objects, each containing a condition to check and the corresponding variable to set to true
      const variablesToCheck = [
        { check: this.checkPermissions, variable: "showPermissions" },
        { check: this.checkManage, variable: "showManage" },
        { check: this.checkApproval, variable: "showApproval" },
        { check: this.checkPortal, variable: "showPortal" },
        { check: this.checkConfigure, variable: "showConfigure" },
        { check: this.checkInterview, variable: "showInterview" },
      ];

      // Iterate over the objects in the variablesToCheck array
      for (const { check, variable } of variablesToCheck) {
        // Check if the condition (check) is true
        if (check) {
          // If the condition is true, set the corresponding variable (variable) to true
          this[variable] = true;
        }
      }
    },

    toggleSidebar() {
      if (this.mini) {
        document.getElementById("mySidebar").style.width = "300px";
        this.mini = false;
      } else {
        document.getElementById("mySidebar").style.width = "85px";
        this.$forceUpdate();
        this.mini = true;
      }
    },
    closeSideBar() {
      this.$store.commit("userVUEX/setMenuStatus", false);
    },
    goToCandProgress() {
      this.$router.push({ name: "CandJdProgress" });
    },
    goToManage() {
      this.$router.push({
        path: "/data/manage",
        query: {
          status: this.$route.query.status,
          type: this.$route.query.type,
          sort: this.$route.query.sort,
        },
      });
    },
    goToCustomer() {
      this.$router.push({
        name: "Manage",
        query: {
          status: "customer",
        },
      });
    },
    goToVendor() {
      this.$router.push({
        name: "Manage",
        query: {
          status: "manage",
        },
      });
    },
    goToPreviewFeedback() {
      this.$router.push({
        path: "/previewfeedbackform",
      });
    },
    gotovendorlogin() {
      this.$router.push({
        path: "/vendorlogin/vendordashboard",
      });
    },
    gotoTeams() {
      this.$router.push({
        path: "/teams",
      });
    },
    gotoPanelLogin() {
      this.$router.push({
        path: "/panellogin",
      });
    },
    gotoCustomField() {
      this.$router.push({
        path: "/customfield/customform",
      });
    },
    goToDocuments() {
      this.$router.push({
        path: "/documents",
      });
    },
    gotoThirdParty() {
      this.$router.push({
        name: "ThirdParty",
      });
    },
    goToPanellist() {
      this.$router.push({
        path: "/permission/panel/list",
      });
    },
    goToUploaddocuments() {
      this.$router.push({
        path: "/hr/upload-documents",
      });
    },
    goToCvSearch() {
      this.$router.push({
        name: "cvSearchTalentPool",
      });
    },
    goToWorkBench() {
      this.$store.commit("userVUEX/setCurrentComponent", "Workbench");
      this.$router.push({
        path: "/",
      });
    },
    goToMainDashboard() {
      this.$router.push({
        name: "MainDashboard",
      });
    },
    goToJobDashboard() {
      if (
        this.$route.query.status === "recruiterview" ||
        (this.roles.includes("RECRUITER_VIEW") && !this.$route.query.status)
      ) {
        this.$router.push({
          name: "JobDashboard",
          query: {
            status: "recruiterview",
          },
        });
      } else {
        this.$router.push({
          name: "JobDashboard",
          query: {
            status: "jobview",
          },
        });
      }
    },
    goToHrPortal() {
      this.$router.push({
        name: "Dashboard",
      });
    },

    goToTalentPool() {
      this.$store.commit("userVUEX/setCurrentComponent", "TalentPool");
      this.$router.push({
        name: "TalentPool",
      });
    },
    goToReport() {
      this.$router.push({
        name: "ReportDashboard",
      });
    },
    // gotoaccesscontrol() {
    //   this.$router.push({
    //     name: "AccessControl",
    //   });
    // },
    goToAccessPanel() {
      this.$router.push({ path: "/permission" });
    },
    goToRoles() {
      this.$router.push({ path: "/permission", query: { status: "roles" } });
    },
    goToPool() {
      this.$router.push({
        name: "TalentPool",
      });
    },
    goToRoute(status) {
      this.$router.push({
        name: "HiringProcessDashboard",
        query: {
          type: "1",
          sort: "6",
          status: status,
        },
      });
    },

    gotojdapproval() {
      this.$router.push({
        name: "ViewJds",
      });
    },
    gotocandidateapproval() {
      this.$router.push({
        name: "ReviewCandidates",
      });
    },
    goToTransactions() {
      this.$router.push({
        name: "Transactions",
      });
    },
  },
};
</script>

<style>
.head-activenavclass {
  color: var(--bluetheme) !important ;
  font-size: 15px;
  font-weight: 600;
  font-family: "Montserrat", sans-serif;
  cursor: pointer;
}

.head-inactivenavclass {
  color: #324054 !important;
  font-family: "Montserrat", sans-serif;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.icon-cont {
  width: 25px;
  height: 25px;
}
.openwidth-sidebar {
  width: 230px;
}
.closewidth-sidebar {
  width: 55px;
}
.trans {
  transition: width 1s;
}
.side-close {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 30px;
  height: 30px;
  border-radius: 14px;
  left: 213px;
  top: 50%;
  background: #ffffff;
  box-shadow: 0px 2px 11px rgba(0, 0, 0, 0.25);
  z-index: 9561545454;
}
.sub-activenavclass {
  margin-left: 14px;
  margin-right: 5px;
  border-radius: 5px;
  padding: 6px 13px;
  width: 100%;
  background-color: #e8eff4;
  color: #20639b;
  font-family: "montserrat", sans-serif;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
}
.sub-inactivenavclass {
  margin-left: 14px;
  margin-right: 5px;
  border-radius: 5px;
  padding: 6px 13px;
  width: 100%;
  background-color: #fcfcfc;
  color: #344054;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  font-family: "montserrat", sans-serif;
}

.sub-inactivenavclass:hover {
  margin-left: 14px;
  margin-right: 5px;
  border-radius: 5px;
  padding: 6px 13px;
  width: 100%;
  background-color: #e8eff4;
  color: #344054;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  font-family: "montserrat", sans-serif;
}

.mr-1px {
  margin-right: 1px;
}
</style>
